import React from 'react'

import ProductsList from '../components/ProductsList'

function Home() {
  return (
    <div className="page-wrapper">
      <ProductsList />
    </div>
  )
}

export default Home
